import React from 'react';
import { DocumentsUsefulStyles } from './DocumentsUseful.styles';
import { UsefulDocuments } from '../UsefulDocuments/UserfulDocuments';

function DocumentsUseful() {
  return (
    <DocumentsUsefulStyles>
      {/* <Joyride
        steps={steps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,

          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackProfile(data, steps, setState)}
        showSkipButton
        showProgress
      />
      {localStorage.getItem('profilo') === 'done' && (
      <div style={{ cursor: 'pointer' }} onClick={() => fireNewQuoteTour()} className="mb-3 ">
        <button className="btn btn-success">Tutorial</button>
      </div>
      )} */}
      <div className="row">
        <div className="col-xl-12">
          <UsefulDocuments />

        </div>
      </div>
    </DocumentsUsefulStyles>
  );
}

export default DocumentsUseful;
